import { helpers } from 'vuelidate/lib/validators';
export default helpers.regex('ticketNumber', /^[0-9]{3}-[0-9]{10}$/);
